export default __webpack_public_path__ + "0af0217df207e5d0787f2afe9b74151a.woff";